import ProductAdd from "./ProductAdd";
import ProductUpdate from "./ProductUpdate";

export const ProductAddView = ProductAdd;
export const ProductUpdateView = ProductUpdate;
